import {NavigationState} from '../../../common/navigator';
import * as React from 'react';
import { Article } from '@wix/answers-api';
import {Icon, iconsMap} from '../../../common/icons/icon.comp';

export interface ArticleListProps {
	articles: Article[];
	withIcons?: boolean;
	goToState: (state: NavigationState, data: any) => void;
	onSelectCallback?: (article: Article, idx: number) => void;
}

export class ArticleList extends React.Component<ArticleListProps, any> {
	articleClick (article: Article, idx: number) {
		const props = this.props;
		props.goToState(NavigationState.article, article.id);
		if (props.onSelectCallback) {
			props.onSelectCallback(article, idx);
		}
	}

	render () {
		const articleIcon = this.props.withIcons ? <Icon icon={iconsMap.articleThumb} /> : null;
		const item = (article: Article, idx: number) => (
			<li className='article' key={article.id}>
				<a onClick={() => this.articleClick(article, idx)}>
					{articleIcon}
					<div className='title'>{article.title}</div>
				</a>
			</li>
		);

		return (
			<ul className='articles'>
				{this.props.articles.map(item)}
			</ul>
		);
	}
}
